<template>
	<div class="card-carousel-wrapper">
		<div class="card-carousel">
			<div class="navigation nav-left">
				<button
					:disabled="atHeadOfList"
					:aria-hidden="atEndOfList"
					class="btn-left"
					name="prev-card"
					:aria-label="$t('goPrevCluster')"
					@click="moveCarousel(-1)"
					@mousedown.prevent
				>
					<svgicon name="arrow" class="arrow left"></svgicon>
				</button>
			</div>

			<div class="card-carousel-overflow-container">
				<div
					class="card-carousel-cards"
					:style="{
						transform: 'translateX' + '(' + currentOffset + 'px' + ')'
					}"
				>
					<div
						v-for="(item, i) in filteredCareerClusters"
						:key="i"
						class="card-carousel-card"
						:class="{ 'card-center': i === currentElementIndex }"
					>
						<div class="card-inner">
							<img class="card-image" :src="item.imageBase64" alt="" />

							<div class="card-content">
								<div class="card-content-inner">
									<div class="heading-2 card-title">{{ item.name }}</div>
								</div>

								<ja-button
									:name="'explore' + i"
									class="small outlined"
									:disabled="i != currentElementIndex"
									:aria-hidden="i != currentElementIndex"
									:aria-label="
										$t('exploreCareerMsg', { careerCluster: item.name })
									"
									@click.native.once="selectCluster(item)"
									>{{ $t('explore') }}</ja-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="navigation nav-right">
				<button
					:disabled="atEndOfList"
					:aria-hidden="atEndOfList"
					class="btn-right"
					name="next-card"
					:aria-label="$t('goNextCluster')"
					@click="moveCarousel(1)"
					@mousedown.prevent
				>
					<svgicon name="arrow" class="arrow"></svgicon>
				</button>
			</div>
		</div>

		<div class="indicatior-wrapper">
			<ja-indicators
				:data="filteredCareerClusters"
				:current-el="currentElementIndex"
				:show-el="showElement"
			/>
		</div>
	</div>
</template>
<script>
import '../icons/arrow';
import Button from '../ui/Button';
import Indicators from '../ui/Indicators';

export default {
	components: {
		jaButton: Button,
		jaIndicators: Indicators
	},
	props: {
		items: {
			type: Array,
			required: true
		},
		selectedCluster: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			currentOffset: 0,
			windowSize: 1,
			paginationFactor: 600,
			filteredCareerClusters: this.filterClusters(),
			currentElementIndex: 0
		};
	},
	computed: {
		atEndOfList() {
			return (
				this.currentOffset <=
				this.paginationFactor *
					-1 *
					(this.filteredCareerClusters.length - this.windowSize)
			);
		},
		atHeadOfList() {
			return this.currentOffset === 0;
		},
		currentElement() {
			return this.cards[this.currentElementIndex];
		}
	},
	mounted() {
		if (this.selectedCluster) {
			this.currentElementIndex = this.filteredCareerClusters.findIndex(item => {
				return this.selectedCluster == item.careerCluster_ID;
			});

			this.currentOffset -= this.paginationFactor * this.currentElementIndex;
		}
	},
	methods: {
		filterClusters() {
			return this.items.filter(function(item) {
				return item.cmsCareers.length;
			});
		},
		selectCluster(item) {
			this.$emit('selectCluster', item);
		},
		moveCarousel(direction) {
			if (direction === 1 && !this.atEndOfList) {
				this.currentOffset -= this.paginationFactor;
				this.currentElementIndex++;
			} else if (direction === -1 && !this.atHeadOfList) {
				this.currentOffset += this.paginationFactor;
				this.currentElementIndex--;
			}
		},
		showElement(elementIndex) {
			var diff = Math.abs(this.currentElementIndex - elementIndex);
			if (elementIndex > this.currentElementIndex) {
				this.currentOffset -= diff * this.paginationFactor;
				this.currentElementIndex = elementIndex;
				this.currentElementIndex;
			} else {
				this.currentOffset += diff * this.paginationFactor;
				this.currentElementIndex = elementIndex;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.card:not(.inline) {
	width: 100%;
	min-width: 500px;
}

.card-carousel-wrapper {
	.card-carousel {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 50%;
		position: relative;

		.card-carousel-cards {
			display: inline-flex;
			transition: transform 0.4s ease-out;
			transform: translatex(0px);
			height: 100%;
			margin-left: -55px;

			&:hover {
				cursor: default;
			}
		}

		.card {
			@media (any-hover: hover) {
				&:hover {
					background-color: $container-bgcolor;
					border: 1px solid $container-border;
				}
			}
			.card-title {
				color: $font-header;
			}
		}
		.card-center {
			transform: scale(1.1);
		}

		.arrow {
			color: white;
		}
		.left {
			transform: rotate(180deg);
		}

		.navigation {
			button {
				height: 50px;
				width: 50px;
				background-color: $font-blue;
				border: 0;
				border-radius: 50%;
				margin: auto;

				@media (any-hover: hover) {
					&:hover {
						cursor: pointer;
						background-color: $hover-state;
					}
				}

				&:active {
					background-color: $tapped-state;
				}

				&[disabled] {
					background-color: $selected-option-bgcolor;
					cursor: auto;
				}
			}
		}

		.nav-left {
			position: absolute;
			left: 0;
			z-index: 1;
			transform: translateX(-332px);
		}

		.nav-right {
			position: absolute;
			left: 0;
			z-index: 1;
			transform: translateX(295px);
			outline: 0;
		}
	}

	.indicatior-wrapper {
		margin: 64px 0 48px 0;

		ul {
			list-style: none;
			display: flex;
			//justify-content: space-between;
			padding-inline-start: 0px;

			li {
				text-decoration: none;
				margin: auto;

				.indicator-btn {
					height: 8px;
					width: 8px;
					background-color: $cluster-pagination-btn;
				}
			}
		}
	}
}

$imageSize: 248px;

/* card carousel */
.card-carousel-overflow-container {
	display: flex;
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;
	transform: translateX(-240px);
}

/* card */
.card-carousel-card {
	width: 500px;
	box-shadow: 0 15px 30px 0 #004cd03d;
	border: 1px solid #dde4e6;

	padding: 24px 32px;
	margin: 0 50px;
	text-align: center;
	transition: transform 0.2s ease-in-out;
	border-radius: 6px;

	p {
		margin: 0;

		+ p {
			margin-top: 10px;
		}
	}

	.card-inner {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.card-image {
		width: $imageSize;
		height: $imageSize;
		margin: 0 auto 16px;
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		border-radius: 100%;
	}

	.card-title {
		margin: 0;
		padding: 0;
		line-height: 32px;
		color: #363e52;
	}

	.card-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		height: calc(100% - #{$imageSize});

		&-inner {
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: 50%;
		}

		button {
			margin-top: 16px;
		}
	}

	.card__btn {
		margin-top: 16px;
		display: inline-block;
		min-width: 130px;
		text-align: center;
		padding: 10px;
		box-shadow: 0 0 10px 2px #a7c6e1;
		border-radius: 30px;
		width: 130px;
		border: 2px solid $selected-card-color;
		border-radius: 22px;
	}

	/* card modifier */
	&--center {
		transform: scale(1.05);
	}
}
</style>
